import React, { useEffect } from 'react';
import LiveMapPage from './live-map/LiveMapPage';
import './users/users.css';
import './users/brand.css';
import './live-map/map.css';

// Apple MapKit JS Tokens - Multiple origins supported
const MAPKIT_TOKENS: Record<string, string> = {
    'lifeshare-1465d.web.app': 'eyJraWQiOiJCOEhBTjlUTTg5IiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiI5NDRZQUdGNkpRIiwiaWF0IjoxNzY5NzUzMzgwLCJvcmlnaW4iOiJsaWZlc2hhcmUtMTQ2NWQud2ViLmFwcCJ9.71FYe9c-PTgED4ghBe6OzbEjdcB4aznqLGZDk5U_CaCAiM8vhXv73j9ij66xYgsiAvljyEfqGjyvmsLc2VyKbA',
    'admin.lifeshare.app': 'eyJraWQiOiJQOFNUMzlOTkROIiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiI5NDRZQUdGNkpRIiwiaWF0IjoxNzY5NzUzMTc4LCJvcmlnaW4iOiJhZG1pbi5saWZlc2hhcmUuYXBwIn0.1NHZ-er4bqWF3ja5TB-q60KiRr5zYz7-E2gF7S0ifpMSQUMBaHBNPVgjYeOXsWQHrwQW5BKivmvwMn0lDs3vaQ',
    'localhost': 'eyJraWQiOiI4WUQ1MjRQODhCIiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiI5NDRZQUdGNkpRIiwiaWF0IjoxNzY2ODY2NTM2LCJvcmlnaW4iOiJsb2NhbGhvc3QifQ.PLACEHOLDER_NEED_NEW_TOKEN'
};

// Get token for current hostname
const getMapKitToken = (): string => {
    const hostname = window.location.hostname;
    return MAPKIT_TOKENS[hostname] || MAPKIT_TOKENS['lifeshare-1465d.web.app'];
};

export default function LiveMap() {
  useEffect(() => { document.body.classList.add('users-brand'); return () => document.body.classList.remove('users-brand'); }, []);
  return <LiveMapPage tokenProvider={getMapKitToken} />;
}
